export default __webpack_public_path__ + "static/Parental Nomination of Guardian and Homestay Form-4f8c1e322f10cf0cc6f8eff1479cd169.pdf";